import { useId, useState } from "react";
import { ChevronDown } from "lucide-react";
import { VOCI_PERCHE } from "@/lib/analisiScritte";

/** «Perché» sotto la voce: al tocco apre la spiegazione dentro la riga, uguale con mouse, dito e tastiera
 *  (ui-ux-pro-max: hover-vs-tap, touch-target-size, progressive-disclosure). */
export function Perche({ testo }: { testo: string | null | undefined }) {
  if (!testo) return null;
  return (
    <details className="group mt-0.5">
      <summary className="min-h-[44px] -my-2 inline-flex items-center gap-1 text-xs font-semibold text-brand-dark cursor-pointer list-none [&::-webkit-details-marker]:hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand rounded">
        {VOCI_PERCHE}
        <ChevronDown className="w-3.5 h-3.5 transition-transform group-open:rotate-180 motion-reduce:transition-none" aria-hidden="true" />
      </summary>
      <p className="text-xs leading-relaxed bg-surface rounded-md p-2.5 mt-1 font-normal">{testo}</p>
    </details>
  );
}

/** Tabella del computer: «Perché» sotto la voce, il testo su una riga intera della tabella (non stretto nella prima
 *  colonna). Bottone con aria-expanded: stesso comportamento di <details> con mouse, dito e tastiera. */
export function usePercheRiga(testo: string | null | undefined, colonne: number) {
  const [aperto, setAperto] = useState(false);
  const id = useId();
  if (!testo) return { bottone: null, riga: null, aperto: false };
  const bottone = (
    <button type="button" onClick={() => setAperto((x) => !x)} aria-expanded={aperto} aria-controls={id}
      className="min-h-[44px] -my-2 mt-0.5 flex w-fit items-center gap-1 text-xs font-semibold text-brand-dark cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand rounded">
      {VOCI_PERCHE}
      <ChevronDown className={`w-3.5 h-3.5 transition-transform motion-reduce:transition-none ${aperto ? "rotate-180" : ""}`} aria-hidden="true" />
    </button>
  );
  const riga = aperto ? (
    <tr id={id}>
      <td colSpan={colonne} className="pb-3 pt-0">
        <p className="text-xs leading-relaxed bg-surface rounded-md p-2.5 max-w-[65ch]">{testo}</p>
      </td>
    </tr>
  ) : null;
  return { bottone, riga, aperto };
}
